import {
    type ApiMessageAction,
    EnumMessageAction,
    useActionMessage,
    useToasts,
} from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { useLatestInvoiceIds } from './useLatestInvoiceIds';
import { useClientNavigate } from '../../Routing/useClientNavigate';

export function isActionMessageToLoadInvoices(message: ApiMessageAction) {
    return message.action === EnumMessageAction.LoadRelatedData && message.resource_type === 'invoices';
}

let invoiceCreationNotifications: string[] = [];
export function registerInvoiceCreationNotification(id: string) {
    invoiceCreationNotifications.push(id);
}

export function useNotifyCreatedInvoices() {
    const navigate = useClientNavigate();
    const { storeLatestInvoiceIds } = useLatestInvoiceIds();
    const { remove } = useToasts();

    const writeIdsToSessionStorage = useCallback(
        (message: ApiMessageAction) => {
            const option = message.options[0];
            const parsed = JSON.parse(option.value);
            storeLatestInvoiceIds(parsed);

            const notificationIds = invoiceCreationNotifications;
            invoiceCreationNotifications = [];
            notificationIds.forEach(remove);
        },
        [storeLatestInvoiceIds, remove],
    );

    const navigateToLatestView = useCallback(() => {
        navigate('/billing/invoices/create?mode=latest');
    }, [navigate]);

    useActionMessage({
        canHandle: isActionMessageToLoadInvoices,
        handleMessage: writeIdsToSessionStorage,
        handleOption: navigateToLatestView,
    });
}
